module.exports = __webpack_public_path__ + "img/2-2.ea9a050c.png";